let echartsReady: Promise<boolean> | null = null

export function loadEcharts(): Promise<boolean> {
    if (echartsReady) return echartsReady

    echartsReady = (async () => {
        try {
            const { default: echarts } = await import('./echartsSetup')
            ;(window as any).echarts = echarts
            return true
        } catch (e) {
            console.error('[ECharts] Error cargando chunk local', e)
            echartsReady = null // permite reintentar
            return false
        }
    })()

    return echartsReady
}

// let echartsReady: Promise<boolean> | null = null

// export function loadEcharts(timeoutMs = 5000): Promise<boolean> {
//     if (echartsReady) return echartsReady

//     echartsReady = (async () => {
//         const loadScript = (url: string) =>
//             new Promise<boolean>((resolve) => {
//                 const s = document.createElement('script')
//                 s.src = url
//                 s.async = true

//                 s.onload = () => {
//                     // console.info(`[ECharts] Script cargado: ${url}`)
//                     resolve(true)
//                 }

//                 s.onerror = () => {
//                     console.error(`[ECharts] Error cargando script: ${url}`)
//                     resolve(false)
//                 }

//                 document.head.appendChild(s)
//             })

//         // Declarar timeoutId primero
//         let timeoutId: number | null = null

//         const timeout = new Promise<boolean>((resolve) => {
//             timeoutId = window.setTimeout(() => {
//                 console.error(`[ECharts] Timeout después de ${timeoutMs}ms`)
//                 resolve(false)
//             }, timeoutMs)
//         })

//         const url = 'https://cdn.jsdelivr.net/npm/echarts@6/dist/echarts.min.js'

//         const ok = await Promise.race([loadScript(url), timeout])

//         // Cancelar timeout solo si existe
//         if (timeoutId !== null) {
//             clearTimeout(timeoutId)
//         }

//         if (!ok) {
//             console.error('[ECharts] No se pudo cargar ECharts desde CDN')
//             return false
//         }

//         if (typeof (window as any).echarts === 'undefined') {
//             console.error('[ECharts] Script cargado pero "echarts" no está disponible')
//             return false
//         }

//         // console.info('[ECharts] ECharts está listo')
//         return true
//     })()

//     return echartsReady
// }
